export const WaitingForInit = () => {
  return (
    <div
      style={{
        zIndex: 10,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "rgba(0,0,0,0.8)",
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      Waiting for SwapperSDK initialization ...
    </div>
  );
};
